import {useInfiniteQuery} from 'react-query';
import {userMessages} from 'services/farm/chatMessages';

const useUserMessages = (id: string | undefined) => {
  const {
    data: messages,
    isLoading: isRoomLoading,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery(
    ['user-wholesaler-messages', id],
    ({pageParam = 1, queryKey}) =>
      userMessages(queryKey[1] as string, pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages[allPages.length - 1].next
          ? new URL(allPages[allPages.length - 1]?.next || '').searchParams.get(
              'page',
            )
          : undefined;
      },
    },
  );
  return {messages, isRoomLoading, refetch, fetchNextPage};
};
export default useUserMessages;
